import { IKraxiConfig } from "@origin-digital/kraxi/src/config/IKraxiConfig";
import { KrakenClientConfigs } from "@origin-digital/kraxi/src/config/presetHelper";

const lpgLocalConfig: IKraxiConfig = {
  environment: "local",
  graphqlUrl: "http://localhost:3004/v1/lpg/graphql",
  authorizationMode: "none",
  apolloDevToolsEnabled: true,
};

const lpgDevConfig: IKraxiConfig = {
  environment: "dev",
  graphqlUrl: "https://api-dev.rx.originenergy.com.au/v1/lpg/graphql",
  authorizationMode: "jwt",
  apolloDevToolsEnabled: false,
};

const lpgTestConfig: IKraxiConfig = {
  environment: "test",
  graphqlUrl: "https://api-test.rx.originenergy.com.au/v1/lpg/graphql",
  authorizationMode: "jwt",
  apolloDevToolsEnabled: false,
};

const lpgStagingConfig: IKraxiConfig = {
  environment: "staging",
  graphqlUrl: "https://api-test.rx.originenergy.com.au/v1/lpg/graphql",
  authorizationMode: "jwt",
  apolloDevToolsEnabled: false,
};

const lpgProdConfig: IKraxiConfig = {
  environment: "prod",
  graphqlUrl: "https://api.rx.originenergy.com.au/v1/lpg/graphql",
  authorizationMode: "jwt",
  apolloDevToolsEnabled: false,
};

export const lpgConfigs: KrakenClientConfigs = {
  local: lpgLocalConfig,
  dev: lpgDevConfig,
  test: lpgTestConfig,
  staging: lpgStagingConfig,
  regress: lpgStagingConfig,
  prod: lpgProdConfig,
};
